module.exports = __webpack_public_path__ + "static/media/Rede-Varejao-01.e6be959b.jpg";